module.exports = __webpack_public_path__ + "static/media/calendar-24px.e941c85b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/Nebula/DateField/assets/calendar-24px.svg
// module id = 1806
// module chunks = 83